import React from 'react';
import Lottie from "lottie-react";
import { motion } from "framer-motion";
import animationData from "../../assets/katedral-loader.json";

const LoaderOne = () => {
    const lottieRef = React.useRef();

    React.useEffect(() => {
        if (lottieRef.current) {
            lottieRef.current.setSpeed(0.5);
        }
    }, []);

    return (
        <div className="flex flex-col items-center justify-center">
            <div className="w-48 h-48">
                <Lottie
                    lottieRef={lottieRef}
                    animationData={animationData}
                    loop={true}
                    autoplay={true}
                />
            </div>

            <div className="w-48 h-1.5 bg-gray-100 rounded-full mt-2 overflow-hidden">
                <motion.div
                    className="h-full bg-[#FF7F24] rounded-full"
                    initial={{ width: "0%" }}
                    animate={{ width: "100%" }}
                    transition={{
                        duration: 2.5,
                        ease: "easeInOut"
                    }}
                />
            </div>
        </div>
    )
}

export default LoaderOne;
